import { useLDClient } from 'launchdarkly-react-client-sdk';

import { useLocation } from 'src/queries/curbside/location-details';

export type PrintWorkerDetails = {
  isPrintWorkerEnabled: boolean;
};

export const usePrintWorker = (): PrintWorkerDetails => {
  const ldClient = useLDClient();
  const isLdFlagEnabled = !!ldClient?.variation('print.print-service.rollout', false);

  const { data: location } = useLocation();
  const isPrintWorkerFeatureFlagEnabled = !!location?.Features['UsePrintWorker'];
  const hasPrintWorkerLocation = !!location?.PrintWorkerLocationGuid;

  return {
    isPrintWorkerEnabled: isLdFlagEnabled && isPrintWorkerFeatureFlagEnabled && hasPrintWorkerLocation,
  };
};
